import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import CopyClipboard from '../CopyClipboard/CopyClipboard';
import ColorSF2 from '../../styles/common/ColorSF2';

const Main = styled.div`
  min-height: 270px;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px 10px 0px 10px;
  font-size: 14px;
  background-color: ${ColorSF2.white};
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  min-height: 50px;
  @media (max-height: 530px) {
    margin: 1px 4px 1px 4px;
    font-size: 12px;
    min-height: 40px;
  }
`;

const ItemWrapperTop = styled(ItemWrapper)`
  margin-top: 2px;
`;

const ItemTitle = styled.div`
  flex: 0 0 150px;
  padding: 10px;
  background-color: ${ColorSF2.paleBlue};
  border-right: 1px solid ${ColorSF2.mediumGray};
  display: flex;
  align-items: center;
  padding-left: 10px;
`;

const ItemInfo = styled.div`
  flex: 0 0 430px;
  // min-height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
  flex-wrap: wrap;
  word-break: break-all;
  @media (max-height: 530px) {
    flex: 0 0 400px;
  }
`;

const ItemActivatedWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ItemActivated = styled.div`
  font-size: 12px;
`;

const ItemSubWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

const ItemSubTitle = styled.div`
  font-size: 12px;
  margin-right: 5px;
`;

const ScrollArea = styled.div`
  width: 100%;
  margin: 5px 0px;
  overflow-y: scroll;
  max-height: 60px;
`;

const InputLatLng = styled.input`
  width: 100px;
  line-height: 20px;
  background-color: ${props => (props.error ? '#faa' : '#fff')};
`;

const MapButton = styled.div`
  color: ${ColorSF2.white};
  background-color: ${ColorSF2.green};
  border-radius: 6px;
  width: 60px;
  height: 30px;
  margin: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DownloadFileNamePatternArea = styled.div`
  margin: 5px 0;
`;

const RadioGroup = styled.div`
  width: 100%;
  margin: 8px 5px;
  padding-left: 5px;
`;

const RadioContent = styled.div`
  width: 100%;
`;

const RadioInput = styled.input``;
const RadioLabel = styled.label`
  margin-left: 6px;
`;

const RadioDescription = styled.div`
  width: 100%;
  margin-left: 20px;
  font-size: 12px;
  color: #666666;
`;

const OperatorDeviceLimitArea = styled.div`
  display: flex;

  > ${RadioContent} {
    margin-right: 20px;
  }
`;

const downloadFileNamePatternId = [
  { id: 0, name: '日付', description: '[年月日_時分秒]-[ユーザー名]​' },
  {
    id: 1,
    name: 'グループ',
    description: '[年月日_時分秒]-[グループ名]-[ユーザー名]​',
  },
  {
    id: 2,
    name: 'タグ',
    description: '[年月日_時分秒]-[タグ]-[メモ]-[ユーザー名]​',
  },
];

const UpdateCompany = ({
  currentCompanyInfo,
  confirmData,
  confirmDataError,
  onUpdateConfirm,
  onSearchLatLng,
}) => {
  // ユーザーデバイス上限数のフック情報生成
  const [operatorDeviceLimitSelected, setOperatorDeviceLimitSelected] =
    useState(confirmData.operatorDeviceLimit);
  const operatorDeviceLimitChanged = e => {
    setOperatorDeviceLimitSelected(e.target.value);
    onUpdateConfirm({
      operatorDeviceLimit: e.target.value,
    });
  };
  // ダウンロードファイル名形式のフック情報生成
  const [downloadFileNamePatternSelected, setDownloadFileNamePatternSelected] =
    useState(confirmData.downloadFileNamePatternId);
  const downloadFileNamePatternChanged = e => {
    setDownloadFileNamePatternSelected(e.target.value);
    onUpdateConfirm({
      downloadFileNamePatternId: e.target.value,
    });
  };

  const activated = currentCompanyInfo.activatedAt || false;
  const activationStatusMessage = (activated && (
    <FormattedMessage id="company.UpdateCompany.title.activate.activated" />
  )) || (
    <FormattedMessage id="company.UpdateCompany.title.activate.notActivated" />
  );
  const ciosv2Company = !!currentCompanyInfo.activationCode;
  return (
    <Main>
      <ItemWrapperTop>
        <ItemTitle>
          <FormattedMessage id="company.UpdateCompany.title.companyCode" />
        </ItemTitle>
        <ItemInfo>{currentCompanyInfo.companyCode}</ItemInfo>
      </ItemWrapperTop>
      <ItemWrapper>
        <ItemTitle>
          <FormattedMessage id="company.UpdateCompany.title.companyName" />
        </ItemTitle>
        <ItemInfo>{currentCompanyInfo.companyName}</ItemInfo>
      </ItemWrapper>
      <ItemWrapper>
        <ItemTitle>
          <FormattedMessage id="company.UpdateCompany.title.activationCode" />
        </ItemTitle>
        <ItemInfo>
          <ItemActivatedWrapper>
            {currentCompanyInfo.activationCode}
            <ItemActivated>
              {(ciosv2Company && activationStatusMessage) || '--'}
            </ItemActivated>
          </ItemActivatedWrapper>
          {currentCompanyInfo.activationCode && (
            <CopyClipboard text={currentCompanyInfo.activationCode} />
          )}
        </ItemInfo>
      </ItemWrapper>
      <ItemWrapper>
        <ItemTitle>
          <FormattedMessage id="company.UpdateCompany.title.zipCode" />
        </ItemTitle>
        <ItemInfo>{currentCompanyInfo.zipCode}</ItemInfo>
      </ItemWrapper>
      <ItemWrapper>
        <ItemTitle>
          <FormattedMessage id="company.UpdateCompany.title.address" />
        </ItemTitle>
        <ItemInfo>
          <ScrollArea>{currentCompanyInfo.address}</ScrollArea>
        </ItemInfo>
      </ItemWrapper>
      <ItemWrapper>
        <ItemTitle>
          <FormattedMessage id="company.UpdateCompany.title.latlng" />
        </ItemTitle>
        <ItemInfo>
          <ItemSubWrapper>
            <ItemSubTitle>
              <FormattedMessage id="company.UpdateCompany.title.lat" />
            </ItemSubTitle>
            <InputLatLng
              error={confirmDataError.lat}
              id="updateConfirmInputLat"
              type="text"
              value={confirmData.lat !== null ? confirmData.lat : ''}
              onChange={e => onUpdateConfirm({ lat: e.target.value })}
            />
          </ItemSubWrapper>
          <ItemSubWrapper>
            <ItemSubTitle>
              <FormattedMessage id="company.UpdateCompany.title.lng" />
            </ItemSubTitle>
            <InputLatLng
              error={confirmDataError.lng}
              id="updateConfirmInputLng"
              type="text"
              value={confirmData.lng !== null ? confirmData.lng : ''}
              onChange={e => onUpdateConfirm({ lng: e.target.value })}
            />
          </ItemSubWrapper>
          <MapButton
            id="searchLatLngButtonClick"
            role="presentation"
            className="button"
            onClick={() => {
              onSearchLatLng({ lat: confirmData.lat, lng: confirmData.lng });
            }}
          >
            <FormattedMessage id="company.UpdateCompany.option.map" />
          </MapButton>
        </ItemInfo>
      </ItemWrapper>
      <ItemWrapper>
        <ItemTitle>
          <FormattedMessage id="company.UpdateCompany.title.operatorDeviceLimit" />
        </ItemTitle>
        <ItemInfo>
          <OperatorDeviceLimitArea>
            {[1, 2, 3].map(value => (
              <RadioContent>
                <RadioInput
                  type="radio"
                  name="operatorDeviceLimit"
                  value={value}
                  id={`operator-device-limit-${value}`}
                  checked={value === Number(operatorDeviceLimitSelected)}
                  onChange={operatorDeviceLimitChanged}
                />
                <RadioLabel htmlFor={`operator-device-limit-${value}`}>
                  {value}
                  <FormattedMessage id="company.UpdateCompany.title.operatorDeviceLimit.unit" />
                </RadioLabel>
              </RadioContent>
            ))}
          </OperatorDeviceLimitArea>
        </ItemInfo>
      </ItemWrapper>
      <ItemWrapper>
        <ItemTitle>
          <FormattedMessage id="company.UpdateCompany.title.downloadFileNamePatternId" />
        </ItemTitle>
        <ItemInfo>
          <DownloadFileNamePatternArea>
            {downloadFileNamePatternId.map(value => (
              <RadioGroup key={`download-file-name-pattern-${value.id}`}>
                <RadioContent>
                  <RadioInput
                    type="radio"
                    name="downloadFileNamePatternId"
                    value={value.id}
                    id={`download-file-name-pattern-${value.id}`}
                    checked={
                      value.id === Number(downloadFileNamePatternSelected)
                    }
                    onChange={downloadFileNamePatternChanged}
                  />
                  <RadioLabel
                    htmlFor={`download-file-name-pattern-${value.id}`}
                  >
                    {value.name}
                  </RadioLabel>
                </RadioContent>
                <RadioDescription>{value.description}</RadioDescription>
              </RadioGroup>
            ))}
          </DownloadFileNamePatternArea>
        </ItemInfo>
      </ItemWrapper>
    </Main>
  );
};

UpdateCompany.propTypes = {
  currentCompanyInfo: PropTypes.object.isRequired,
  confirmData: PropTypes.object.isRequired,
  confirmDataError: PropTypes.object.isRequired,
  onUpdateConfirm: PropTypes.func.isRequired,
  onSearchLatLng: PropTypes.func.isRequired,
};

export default UpdateCompany;
